import { useEffect, useState } from 'react';
import { useAxios } from '../../Helpers/AxiosHelper';
import { AutoComplete, AutoCompleteChangeEvent, AutoCompleteCompleteEvent } from '../../Common/Imports';
import { ApiResponse, Reservations_EXT } from '../../Models/Classes';

interface DDReservationsProps {
    onChange?: (IdReservation: number | undefined) => void;
    value?: number;
    Reservation?: Reservations_EXT;
    onBlur?: () => void;
}

export const DDReservations: React.FC<DDReservationsProps> = ({ value, onChange, onBlur, Reservation }) => {
    const [data, setData] = useState<Reservations_EXT[] | undefined>([]);
    const [selectedElem, setSelectedElem] = useState<Reservations_EXT | undefined>();
    const AxiosHelper = useAxios();

    const Search = async (event: AutoCompleteCompleteEvent) => {
        try {
            const resp = await AxiosHelper.get<ApiResponse<Reservations_EXT[]>>(`DropDown/Reservations/` + event.query);
            if (resp.data.code === 0) {
                setData(resp.data.data);
            }
        } catch (error) {
            console.error('Error fetching reservations:', error);
        }
    };

    useEffect(() => {
        const fetchReservations = async () => {
            if (value !== undefined) {
                try {
                    const resp = await AxiosHelper.get<ApiResponse<Reservations_EXT>>(`Reservation/Get/` + value);
                    if (resp.data.code === 0) {
                        setSelectedElem(resp.data.data);
                    }
                } catch (error) {
                    console.error('Error fetching reservations:', error);
                }
            }
        };
        if (value)
            fetchReservations();
    }, [value, AxiosHelper]);

    useEffect(() => {
        if (Reservation) {
            setSelectedElem(Reservation);
        }
    }, [Reservation]);

    const handleChange = (e: AutoCompleteChangeEvent) => {
        const _val = e.value as Reservations_EXT;
        setSelectedElem(_val);
        if (onChange) {
            const id = _val?.idReservation as number;
            onChange(id);
        }
    };

    return (
        <AutoComplete
            field="idReservation"
            value={selectedElem}
            suggestions={data}
            completeMethod={Search}
            onChange={handleChange}
            onBlur={onBlur}
        />
    );
};
